var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.1253 36.1508C62.1253 19.9096 49.5228 8.875 35.5003 8.875C21.6257 8.875 8.87533 19.6729 8.87533 36.3283C7.10033 37.3342 5.91699 39.2275 5.91699 41.4167V47.3333C5.91699 50.5875 8.57949 53.25 11.8337 53.25H14.792V35.2042C14.792 23.7554 24.0516 14.4958 35.5003 14.4958C46.9491 14.4958 56.2087 23.7554 56.2087 35.2042V56.2083H32.542V62.125H56.2087C59.4628 62.125 62.1253 59.4625 62.1253 56.2083V52.5992C63.8707 51.6821 65.0837 49.8775 65.0837 47.7475V40.9433C65.0837 38.8725 63.8707 37.0679 62.1253 36.1508Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6253 41.4167C28.2592 41.4167 29.5837 40.0922 29.5837 38.4583C29.5837 36.8245 28.2592 35.5 26.6253 35.5C24.9915 35.5 23.667 36.8245 23.667 38.4583C23.667 40.0922 24.9915 41.4167 26.6253 41.4167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3753 41.4167C46.0092 41.4167 47.3337 40.0922 47.3337 38.4583C47.3337 36.8245 46.0092 35.5 44.3753 35.5C42.7415 35.5 41.417 36.8245 41.417 38.4583C41.417 40.0922 42.7415 41.4167 44.3753 41.4167Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2506 32.6304C51.8306 24.1992 44.494 17.75 35.6485 17.75C26.6848 17.75 17.0406 25.1754 17.8098 36.8312C25.1169 33.8433 30.6194 27.335 32.1873 19.4067C36.0627 27.1871 44.0206 32.5417 53.2506 32.6304Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentDark);
export default __webpack_public_path__ + "static/media/agent_dark.b792cfba1a525ff68e308a6bff0e8bc9.svg";
export { ForwardRef as ReactComponent };